/*
Centralised access to build-time environment variables injected by webpack
DefinePlugin (config/dev.env.js, config/prod.env.js).

Tests can override defaults by setting the underlying process.env values
before requiring this module — webpack inlines the values at build time
in production, but in karma/test the variables are real `process.env`
strings.
------------------------------------------------------------------------ */

function readEnv (key, fallback) {
  // eslint-disable-next-line no-process-env
  var value = (typeof process !== 'undefined' && process.env) ? process.env[key] : undefined
  if (value === undefined || value === null || value === '') {
    return fallback
  }
  return value
}

export const API_BASE_URL = readEnv('API_BASE_URL', '')
export const JWKS_URL = readEnv('JWKS_URL', '/api/.well-known/jwks.json')
export const JWT_ISSUER = readEnv('JWT_ISSUER', 'xolas-tms-api')
export const JWT_AUDIENCE = readEnv('JWT_AUDIENCE', 'xolas-tms-ux')
export const JWT_PROACTIVE_REFRESH_SECONDS = Number(readEnv('JWT_PROACTIVE_REFRESH_SECONDS', '300'))

// API_KEY: legacy shared X-API-Key used for the API client gate. Prod builds
// MUST set XOLAS_API_KEY to a per-environment key issued by the API team;
// the literal here is the legacy dev fallback (XOL-127 / XOL-186 item 2).
export const API_KEY = readEnv('XOLAS_API_KEY', '6d912860-049c-40c8-b714-391df6ac6979')

export default {
  API_BASE_URL: API_BASE_URL,
  JWKS_URL: JWKS_URL,
  JWT_ISSUER: JWT_ISSUER,
  JWT_AUDIENCE: JWT_AUDIENCE,
  JWT_PROACTIVE_REFRESH_SECONDS: JWT_PROACTIVE_REFRESH_SECONDS,
  API_KEY: API_KEY
}
